import { render, staticRenderFns } from "./VlCheckbox.vue?vue&type=template&id=db3733f2&scoped=true&"
import script from "./VlCheckbox.vue?vue&type=script&lang=js&"
export * from "./VlCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3733f2",
  null
  
)

export default component.exports